import $ from 'jquery';
import Mustache from 'mustache';

window.addEventListener('load', function() {

  var $map = $('#map');
  if($map.length <= 0) return; // Only if there is a #map

  var mapGoogle;
  var currentEquipments = [];
  var currentMarkersById = [];
  var currentMarkers = [];
  var currentInfowindows = {};
  var input_search;
  var currentPositionLat = 43.661060;
  var currentPositionLng = 3.912700;
  var filteredEquipmentTypes = [];
  var equipment_infowindow_template;
  var markerHeight = 38.9513108614;
  var dataToRender = {};
  // var dataRendered = '';
  // var dataToRender_labels;
  // var dataToRender_univers;
  var equipmentTypes;
  var lat_min =  999999999;
  var lat_max = -999999999;
  var lng_min =  999999999;
  var lng_max = -999999999;
  var $equipement_search = $('#equipement_search');

  initMap();
  function initMap() {

    // Load Map
    mapGoogle = new google.maps.Map(document.getElementById('map'), {
      zoom: 14,
      center: new google.maps.LatLng(currentPositionLat, currentPositionLng),
      scrollwheel: true,
      zoomControl: true,
      draggable: true,
      mapTypeId: 'roadmap', // roadmap, satellite, terrain, hybrid
    });

    // Get Equipments on Page Load
    loadEquipment();
  }

  // Events when Equipment filters change
  $('.js-equipement_type[type=checkbox]').change(function() { // On Type change
    loadEquipment();
  });
  $( ".equipement_search__submit" ).click(function() { // On Input Button submit
    loadEquipment();
  });
  $equipement_search.keypress(function(event) { // On Input enter
    if (event.keyCode == 13)
      loadEquipment();
  });

  /**
   * Load Equipments on List & Map & Move Map according to results
   */
  function loadEquipment(){
    
    // Get updated filters
    filteredEquipmentTypes = [];
    $.each($('.js-equipement_type[type=checkbox]:checked'), function () {
      filteredEquipmentTypes.push($(this).data('slug'));
    });
    input_search = $equipement_search.val();

    $.ajax({
      type: 'GET',
      url: "/wp-json/jacou/equipments",
      data: {
        lat: currentPositionLat,
        lng: currentPositionLng,
        types: filteredEquipmentTypes,
        input_search: input_search
      },
      success: function(data) {
        currentEquipments = data.equipments;
        addEquipmentsOnMap();

        // // Set recommended zoom - Country vs Street
        // if (viewport)
        //   mapGoogle.fitBounds(viewport);

        // // Set Map center
        // mapGoogle.setCenter(new google.maps.LatLng(currentPositionLat,currentPositionLng));
      }
    });
  }

  /**
   * Add Equipments on Map & Auto Center Map
   */
  function addEquipmentsOnMap() {

    // Clear Map Markers & Infowindows
    $.each(currentMarkersById, function (key, marker) {
      if (marker)
        marker.setMap(null);
    });
    currentMarkersById = [];
    currentInfowindows = [];
    currentMarkers     = [];

    // Create all Equipments Markers & InfoWindows
    equipment_infowindow_template = $('#equipment_infowindow').html();
    Mustache.parse(equipment_infowindow_template);
    dataToRender = {};
    $.each(currentEquipments, function (key, equipment){

      var latitude = parseFloat(equipment.lat);
      var longitude = parseFloat(equipment.lng);
      var myLatLng = new google.maps.LatLng(latitude, longitude);
      var equipmentIcon = {};

      // Update min & max latitude & longitude
      if (lat_min > latitude)  lat_min = latitude;
      if (lat_max < latitude)  lat_max = latitude;
      if (lng_min > longitude) lng_min = longitude;
      if (lng_max < longitude) lng_max = longitude;

      // Create marker
      // If Distributor and Other(s), keep Other(s) only (one bicolor is possible)
      equipmentTypes = [];
      if (equipment.types){
        equipment.types.forEach(type => {
          equipmentTypes.push(type);
        });
      }
      equipmentIcon = {
        path: "M0,-40c-7.312,0 -13.33,6.012 -13.338,13.324c0,12.008 13.338,26.676 13.338,26.676c0,0 13.338,-14.668 13.338,-26.676c-0.008,-7.312 -6.026,-13.324 -13.338,-13.324Zm0,18.67c0,0 0,0 0,0c-2.925,0 -5.332,-2.407 -5.332,-5.332c0,-0.005 0,-0.009 0,-0.014c0,-2.925 2.407,-5.332 5.332,-5.332c2.925,0 5.332,2.407 5.332,5.332c0,0.005 0,0.009 0,0.014c0,2.925 -2.407,5.332 -5.332,5.332c0,0 0,0 0,0Z",
        fillColor: "#000",
        fillOpacity: 1,
        strokeWeight: 0,
        size: new google.maps.Size(markerHeight * 0.668, markerHeight),
        anchor: new google.maps.Point(0,0)
      };
      equipmentIcon = {
        url: equipment.types[0].icon_map.url,
        fillColor: "#000",
        anchor: new google.maps.Point(61, 85),
        strokeWeight: 0,
      };

      var marker = new google.maps.Marker({
        id: equipment.ID,
        map: mapGoogle,
        position: myLatLng,
        icon: equipmentIcon,
      });
      currentMarkersById[equipment['ID']] = marker;
      currentMarkers.push(marker);

      // Store Data & Create Marker InfoWindow
      dataToRender.id = equipment.ID;
      dataToRender.title = equipment.post_title;
      dataToRender.address = equipment.address;
      dataToRender.telephone = equipment.telephone;
      dataToRender.email = equipment.email;
      dataToRender.website = equipment.website;
      dataToRender.description = equipment.description;
      dataToRender.types = [];
      if (equipment.types){
        equipment.types.forEach(type => {
          dataToRender.types.push(type);
        });
        // dataToRender.type_color = "#000";
      }
      var infowindow = new google.maps.InfoWindow({
        content: Mustache.render(equipment_infowindow_template, dataToRender)
      });
      currentInfowindows[equipment['ID']] = infowindow;

      // Open Infowindow when Click on Marker
      google.maps.event.addListener(marker, 'click', function () {
        google.maps.event.trigger(mapGoogle, 'click');
        infowindow.open(mapGoogle, marker);
        $('.equipment--is-selected').removeClass('equipment--is-selected');
        $('.js-equipment#'+equipment['ID']).addClass('equipment--is-selected');
      });
      // Close Infowindow when Click on Map
      google.maps.event.addListener(mapGoogle, 'click', function () {
        infowindow.close();
        $('.equipment--is-selected').removeClass('equipment--is-selected');
      });
    });

    // Center & Zoom Map according to Markers position
    var lat_center = (parseFloat(lat_max) + parseFloat(lat_min)) / 2.0;
    var lng_center = (parseFloat(lng_max) + parseFloat(lng_min)) / 2.0;
    mapGoogle.setCenter(new google.maps.LatLng(lat_center, lng_center));
    mapGoogle.fitBounds(new google.maps.LatLngBounds(
      new google.maps.LatLng(lat_min, lng_min), //bottom left
      new google.maps.LatLng(lat_max, lng_max)  //top right
    ));

  }

});